export default __webpack_public_path__ + "static/media/lexa_logo_m.b5b91538.png";